import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Invite from './pages/Invite';
import Sell from './pages/Sell';
import SellHistory from './pages/SellHistory';
import Kyc from './pages/Kyc';
import Security from './pages/Security';
import Checkin from './pages/Checkin';
import Bind from './pages/Bind';
import BindAlipay from './pages/BindAlipay';
import Wallet from './pages/Wallet';
import Register from './pages/Register';
import Login from './pages/Login';
import Download from './pages/Download';
import Group from './pages/Group';
import Support from './pages/Support';
import Team from './pages/Team';
import Splash from './pages/Splash';
import MainLayout from './components/MainLayout';
import AuthLayout from './components/AuthLayout';
import Address from './pages/Address';
import AddAddress from './pages/AddAddress';
import Leaderboard from './pages/Leaderboard';
import Share from './pages/Share';
import WithdrawResult from './pages/WithdrawResult';
import MeetingBroadcast from './pages/MeetingBroadcast';
import PropertyStatus from './pages/PropertyStatus';
import InvestmentRefund from './pages/InvestmentRefund';
import AssetRestore from './pages/AssetRestore';
import HousingClaim from './pages/HousingClaim';
import LiveStream from './pages/LiveStream';
import VideoPage from './pages/VideoPage';
import PotatoClaim from './pages/PotatoClaim';
import PartyAmnesty from './pages/PartyAmnesty';
import OathApplication from './pages/OathApplication';
import TaxCertificate from './pages/TaxCertificate';
import HouseholdRegistration from './pages/HouseholdRegistration';
import NewIdCard from './pages/NewIdCard';
import NewIdCardResult from './pages/NewIdCardResult';
import PartyInfo from './pages/PartyInfo';
import Welfare from './pages/Welfare';
import Study from './pages/Study';
import Gift from './pages/Gift';
import PartyIcCard from './pages/PartyIcCard';
import Fund from './pages/Fund';
import FundReceipt from './pages/FundReceipt';
import CardPasswordSetup from './pages/CardPasswordSetup';
import DangType from './pages/DangType';
import Guoqing from './pages/Guoqing';
import ZhongyaoAppointment from './pages/ZhongyaoAppointment';
import Cards from './pages/Cards';
import CardProgress from './pages/CardProgress';
import Shenji from './pages/Shenji';
import OneCard from './pages/OneCard';
import MyProperty from './pages/MyProperty';
import RefundProgress from './pages/RefundProgress';

export default function App() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/invite" element={<Invite />} />
        <Route path="/property-status" element={<PropertyStatus />} />
        <Route path="/cards" element={<Cards />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/asset-restore" element={<AssetRestore />} />
        <Route path="/investment-refund" element={<InvestmentRefund />} />
        <Route path="/my-property" element={<MyProperty />} />
      <Route path="/videos" element={<VideoPage />} />
      </Route>
      <Route path="/card-progress" element={<CardProgress />} />
      <Route path="/shenji" element={<Shenji />} />
      <Route path="/one-card" element={<OneCard />} />
      <Route path="/kyc" element={<Kyc />} />
      <Route path="/sell" element={<Sell />} />
      <Route path="/sell/history" element={<SellHistory />} />
      <Route path="/security" element={<Security />} />
      <Route path="/checkin" element={<Checkin />} />
      <Route path="/study" element={<Study />} />
      <Route path="/gift" element={<Gift />} />
      <Route path="/bind" element={<Bind />} />
      <Route path="/bind-alipay" element={<BindAlipay />} />
      <Route path="/wallet" element={<Wallet />} />
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Route>
      <Route path="/download" element={<Download />} />
      <Route path="/group" element={<Group />} />
      <Route path="/support" element={<Support />} />
      <Route path="/team" element={<Team />} />
      <Route path="/address" element={<Address />} />
      <Route path="/address/add" element={<AddAddress />} />
      <Route path="/splash" element={<Splash />} />
      <Route path="/withdraw-result" element={<WithdrawResult />} />
      <Route path="/housing-claim" element={<HousingClaim />} />
      <Route path="/live" element={<LiveStream />} />
      <Route path="/potato-claim" element={<PotatoClaim />} />
      <Route path="/party-amnesty" element={<PartyAmnesty />} />
      <Route path="/oath-application" element={<OathApplication />} />
      <Route path="/tax-certificate" element={<TaxCertificate />} />
      <Route path="/household-registration" element={<HouseholdRegistration />} />
      <Route path="/new-id-card" element={<NewIdCard />} />
      <Route path="/new-id-card-result" element={<NewIdCardResult />} />
      <Route path="/party-ic-card" element={<PartyIcCard />} />
      <Route path="/fund" element={<Fund />} />
      <Route path="/fund-receipt" element={<FundReceipt />} />
      <Route path="/party-info" element={<PartyInfo />} />
      <Route path="/welfare" element={<Welfare />} />
      <Route path="/leaderboard" element={<Leaderboard />} />
      <Route path="/share" element={<Share />} />
      <Route path="/meeting-broadcast" element={<MeetingBroadcast />} />
      <Route path="/card-password-setup" element={<CardPasswordSetup />} />
      <Route path="/dang-type" element={<DangType />} />
      <Route path="/guoqing" element={<Guoqing />} />
      <Route path="/zhongyao" element={<ZhongyaoAppointment />} />
      <Route path="/refund-progress" element={<RefundProgress />} />
    </Routes>
  );
}
